//Mit CodeKit funzt das nicht.
//ins Dev-Verzeichnis und dann: npm run build


import './style.css';

import { Map, View, Feature, Overlay, Extent } from 'ol';
import Point from 'ol/geom/Point';
//import containsCoordinate from 'ol/Extent';
import {containsCoordinate} from 'ol/extent';
import LineString from 'ol/geom/LineString';
import Polygon from 'ol/geom/Polygon.js';
import Cluster from 'ol/source/Cluster';
import Collection from 'ol/Collection.js';
import VectorSource from 'ol/source/Vector';
import DragAndDrop from 'ol/interaction/DragAndDrop.js';
import Draw from 'ol/interaction/Draw.js';
import Modify from 'ol/interaction/Modify.js';
import Interaction from 'ol/interaction/Interaction.js';
import Translate from 'ol/interaction/Translate.js';
import Geolocation from 'ol/Geolocation';
import MapBrowserEvent from 'ol/MapBrowserEvent';
import OSM from 'ol/source/OSM';
import {Icon, Style, Text, Circle as CircleStyle, Fill, Stroke} from 'ol/style';
import {Tile as TileLayer, Vector as VectorLayer} from 'ol/layer';
import {fromLonLat, toLonLat} from 'ol/proj';
import {getBottomLeft, getTopRight, boundingExtent} from 'ol/extent';
import * as olProj from 'ol/proj';
import { parseGPX } from "@we-gold/gpxjs";
import Geocoder from "ol-geocoder";

import * as bootstrap from 'bootstrap';
import $ from 'jquery';
window.$ = window.jQuery = $;

const distanceInput = 20;
const minDistanceInput = 10;
const iconLauf = '/images/jogging.png';
const iconStart = '/images/s.gif';
const iconZiel = '/images/f.gif';
const iconPoint = '/images/p.gif';
const iconKilometermarke = '/zahlen/leer.gif';
const trackStandardFarbe = '#990000';

const bern = fromLonLat([7.4458, 46.95]);

var streckenArray = [];
var refreshsperre = 1;
var points = [];

var popover;
function disposePopover() {
	$(".popover.show").remove();
	if (popover) {
		popover.hide();
		popover.dispose();
		popover = undefined;
	}
}

// Create a map with a default view
const view = new View({
	center: bern,
	zoom: 8,
});

const map = new Map({
	target: 'map',
	layers: [
		new TileLayer({
			source: new OSM()
		})
	],
	view: view
});

const mapVolkslaufkalender = new Map({
	target: 'map-volkslaufkalender',
	layers: [
		new TileLayer({
			source: new OSM()
		})
	],
	view: view
});

const mapVolkslaufkalenderNeueintrag = new Map({
	target: 'map-volkslaufkalender-neueintrag',
	layers: [
		new TileLayer({
			source: new OSM()
		})
	],
	view: view
});

const mapVolkslaufkalenderEintrag = new Map({
	target: 'map-volkslaufkalender-eintrag',
	layers: [
		new TileLayer({
			source: new OSM()
		})
	],
	view: view
});

//vorsichtshalber stillgelegt - erzeugt einen Konsolenfehler, brauchen wir aber vielleicht auch nicht mehr
//function initializeDialogs(){
	//dialog = new bootstrap.Modal(document.getElementById('dialog'), {});
//}
//window.initializeDialogs = initializeDialogs;

function initMapVolkslaufkalenderNeueintrag(){
	startMapFunctions(mapVolkslaufkalenderNeueintrag);
}
window.initMapVolkslaufkalenderNeueintrag = initMapVolkslaufkalenderNeueintrag;

function initMapVolkslaufkalenderBearbeiten(lng,lat){
	setMapView(mapVolkslaufkalenderNeueintrag,[lng,lat],12);
	kartenpunktZeichnen(lng,lat,mapVolkslaufkalenderNeueintrag,1);
}
window.initMapVolkslaufkalenderBearbeiten = initMapVolkslaufkalenderBearbeiten;

function initMapVolkslaufkalender(){
	startMapFunctions(mapVolkslaufkalender);
}
window.initMapVolkslaufkalender = initMapVolkslaufkalender;

function callLocationVolkslaufkalender(){
	startMapFunctions(mapVolkslaufkalender,12);
}
window.callLocationVolkslaufkalender = callLocationVolkslaufkalender;

function callLocationMap(){
	startMapFunctions(map,12);
}
window.callLocationMap = callLocationMap;

function initMapVolkslaufkalenderEintrag(lng,lat){
	setMapView(mapVolkslaufkalenderEintrag,[lng,lat],12);
	kartenpunktZeichnen(lng,lat,mapVolkslaufkalenderEintrag);
}
window.initMapVolkslaufkalenderEintrag = initMapVolkslaufkalenderEintrag;

function kartenpunktZeichnen(lng,lat,karte,movable=0){
	setMapView(karte,[lng,lat],12);
	let kartenpunkt = new Feature({
		geometry: new Point(fromLonLat([parseFloat(lng), parseFloat(lat)])),
	});
	kartenpunkt.setStyle(
		new Style({
			image: new Icon({
				crossOrigin: 'anonymous',
				src: iconLauf,
			}),
			text: new Text({
				text:'',
			}),
		})
	);
	drawMapPoint(kartenpunkt,karte);
	if(movable==1){
		movableKartenpunkt(kartenpunkt);
	}
}

function movableKartenpunkt(kartenpunkt){
	var dragInteraction = new Modify({
		features: new Collection([kartenpunkt]),
		style: null
	});
	dragInteraction.on('modifyend', function (evt) {
		let position = toLonLat(evt.features.getArray()[0].getGeometry().getCoordinates());
		let longitude = position[0];
		let latitude = position[1];
		$("#longitude").val(longitude);
		$("#latitude").val(latitude);
	});
	mapVolkslaufkalenderNeueintrag.addInteraction(dragInteraction);
}

function initMap(){
	startMapFunctions(map);
}
window.initMap = initMap;

function callVolkslaeufeFormular(){
	refreshsperre = 1;
	deleteOverlays(mapVolkslaufkalender);
	$.get("_ajax/volkslaeufe_eingabe.php",function(data){
		$("#eintragen").html(data);
	});
}
window.callVolkslaeufeFormular = callVolkslaeufeFormular;

const showAddressVolkslaufkalenderEintrag = async () => {
	deleteOverlays(mapVolkslaufkalenderNeueintrag);
	var query = $("#volkslauf_ort").val();
	let results = await fetch(nominatimUrl + query).then((res) => 
		res.json()
	);
	if(results.length > 0) {
		let longitude = parseFloat(results[0].lon);
		let latitude = parseFloat(results[0].lat)
		$("#longitude").val(longitude);
		$("#latitude").val(latitude);
		setMapView(mapVolkslaufkalenderNeueintrag,[longitude,latitude],13);
		let kartenpunkt = new Feature({
			geometry: new Point(fromLonLat([longitude, latitude])),
		});
		kartenpunkt.setStyle(
			new Style({
				image: new Icon({
					crossOrigin: 'anonymous',
					src: iconLauf,
				}),
				text: new Text({
					text:'',
				}),
			})
		);
		drawMapPoint(kartenpunkt,mapVolkslaufkalenderNeueintrag);
		movableKartenpunkt(kartenpunkt);
		$("#positionshinweis").show();
	}
	else {alert("Sorry, '" + query + "' konnte nicht gefunden werden.")}
}
window.showAddressVolkslaufkalenderEintrag = showAddressVolkslaufkalenderEintrag;

function volkslaufEintragen(){
	var data = $("#eingabeformular").serialize();
	var url = "_process/volkslauf_eintragen.php";
	$.post(url,data,function(data){
		$("#eingabeformular").html(
			data
		);
		deleteOverlays();
	});
	
}
window.volkslaufEintragen = volkslaufEintragen;

function startMapFunctions(karte,zoom=8){
	refreshsperre = 0;
	if (navigator.geolocation) {
		navigator.geolocation.getCurrentPosition(function(position) {
			var pos = {
				lat: position.coords.latitude,
				lng: position.coords.longitude
			};
			setMapView(karte,[pos.lng,pos.lat],zoom);
		}, function() {
			//console.log('Position kann nicht ermittelt werden');
		});
	} else {
		//console.log('Geolocation nicht verfügbar');
	}
}

function streckenZeigen(){
	refreshsperre = 0;
	callTracks(0);
}
window.streckenZeigen = streckenZeigen;

function wait(){
	$("#wait").show();
}

function waitDone(){
	$("#wait").hide();
}

function downloadUrl(url,callback) {
	var request = window.ActiveXObject ?
	new ActiveXObject('Microsoft.XMLHTTP') :
	new XMLHttpRequest;
	request.onreadystatechange = function() {
		if (request.readyState == 4) {
			callback(request.responseText, request.status);
		}
	};
	request.open('GET', url, true);
	request.send(null);
}

function callVolkslaeufe(){
	//alert(refreshsperre);
	if(refreshsperre!=1){
		wait();
		deleteOverlays(mapVolkslaufkalender);
		clearShortlist();
		let currentMapBounds = getCurrentMapCoordinates(mapVolkslaufkalender);
		let maxX = currentMapBounds[2];
		let maxY = currentMapBounds[3];
		let minX = currentMapBounds[0];
		let minY = currentMapBounds[1];
		
		var datumstart = $("#from").val();
		var datumende = $("#to").val();
		
		var url="/_process/callVolkslaeufe.php?minX=" + minX + "&maxX=" + maxX + "&minY=" + minY + "&maxY=" + maxY + "&datumstart=" + datumstart + "&datumende=" + datumende;		
	
		downloadUrl(url, function(data) {
			var xml = parseXml(data);
			var menge = xml.getElementsByTagName("markers");
			var anzahl = menge[0].getAttribute("anzahl");
			var markers = xml.documentElement.getElementsByTagName("marker");
			var shortlist = '<ul class="list-group">';
			let kartenpunkte = [];
			//console.log(kartenpunkte);
			if(anzahl=='20'){
				$("#alertarea").show();
				$("#shortlist").hide();
			}
			else{
				$("#alertarea").hide();
				$("#shortlist").show();
			}
			for (var i = 0; i < markers.length; i++) {
				var id_volkslauf = markers[i].getAttribute("id_volkslauf");
				var volkslauf_name = markers[i].getAttribute("volkslauf_name");
				var volkslauf_url = markers[i].getAttribute("volkslauf_url");
				var datum = markers[i].getAttribute("datum");
				kartenpunkte.push(createMarkerVolkslaufkalender(markers[i]));
	
				var html = '<div class="infowindow"><a href="volkslaufkalenderEintrag.php?id_volkslauf=' + id_volkslauf + '" class="btn btn-sm btn-primary">' + volkslauf_name + '</a><br />' + datum + '</div>';
				
				var shortlist = shortlist + '<li class="list-group-item">' + datum + '&nbsp;&nbsp;<a href="volkslaufkalenderEintrag.php?id_volkslauf=' + id_volkslauf + '">' + volkslauf_name + '</a></li>';
			}
			//console.log(kartenpunkte);
			drawMapPoints(mapVolkslaufkalender,kartenpunkte);
			var shortlist = shortlist + '</ul>';
			$("#shortlist").html(shortlist);
			$("#shortlist").height($("#map-volkslaufkalender").height()-400);
			waitDone();
		});
	}
}
window.callVolkslaeufe = callVolkslaeufe;

const nominatimUrl = 'https://nominatim.openstreetmap.org/search.php?format=jsonv2&q='
const showAddress = async () => {
	let query = $("#ort").val();
	let results = await fetch(nominatimUrl + query).then((res) => 
		res.json()
	);
	if(results.length > 0) {
		setMapView(map,[results[0].lon,results[0].lat],13);
	}
	else {alert("Sorry, '" + query + "' konnte nicht gefunden werden.")}
};
window.showAddress = showAddress;

function formatDate(date1) {
  return date1.getFullYear() + '-' +
	(date1.getMonth() < 9 ? '0' : '') + (date1.getMonth()+1) + '-' +
	(date1.getDate() < 10 ? '0' : '') + date1.getDate();
}

function hideTrack(id_track){
	if(refreshsperre!=1){
		removeLines(map);
	}
}
window.hideTrack = hideTrack;

function hideTracks(){
	deleteOverlays(map);
	var displayTracks = 0;
	refreshsperre = 1;
}
window.hideTracks = hideTracks;

function secondsToTime(milliseconds){
	var seconds = milliseconds/1000;
	var hours = Math.floor(seconds/3600);
	var seconds = seconds - (hours*3600);
	var minutes = Math.floor(seconds/60);
	var seconds = seconds - (minutes*60);
	var seconds = Math.floor(seconds);
	return hours + ":" + minutes + ":" + seconds;
}

function removeMarkerGpx(id){
	disposePopover();
	points.splice(id,1);
	plotTrack(trackStandardFarbe,false,true);
	initializeTrackEditListeners();
}
window.removeMarkerGpx = removeMarkerGpx;

map.on('moveend', callTracks);
mapVolkslaufkalender.on('moveend', callVolkslaeufe);

function punktIstInMapView(karte,point){
	var extent = karte.getView().calculateExtent(karte.getSize());
	return containsCoordinate(extent,point);
}

function getCurrentMapCoordinates(karte){
	const extent = karte.getView().calculateExtent(karte.getSize());
	const bottomLeft = toLonLat(getBottomLeft(extent));
	const topRight = toLonLat(getTopRight(extent));
	return [wrapLon(bottomLeft[0]),bottomLeft[1],wrapLon(topRight[0]),topRight[1]];
}

function parseXml(str) {
  if (window.ActiveXObject) {
	var doc = new ActiveXObject('Microsoft.XMLDOM');
	doc.loadXML(str);
	return doc;
  } else if (window.DOMParser) {
	return (new DOMParser).parseFromString(str, 'text/xml');
  }
}

function updateTracknameGpx(){
	var daten = $("#editTrackname").serialize();
	$.post("/_process/updateTrackname.php",daten,function(data){
		document.location.reload();
	});
}
window.updateTracknameGpx = updateTracknameGpx;

function callTracks(jump){
	if(refreshsperre!=1){
		wait();
		let currentMapBounds = getCurrentMapCoordinates(map);
		let maxX = currentMapBounds[2];
		let maxY = currentMapBounds[3];
		let minX = currentMapBounds[0];
		let minY = currentMapBounds[1];
	
		//var infoWindow = new google.maps.InfoWindow;
		var displayTracks = 1;
		points = [];
		var jumper = 9;
		var backer = -9;
		
		document.getElementById('track').style.display = 'none';
		var url="_process/calltracks3.php?minX=" + minX + "&maxX=" + maxX + "&minY=" + minY + "&maxY=" + maxY;
	
		if(jump){
			var url = url + "&jump=" + jump;
			var jumper = jump + 9;
			var backer = jump - 9;
		}
		
		downloadUrl(url, function(data) {
			var xml = parseXml(data);
			var menge = xml.getElementsByTagName("markers");
			var anzahl = menge[0].getAttribute("anzahl");
			var markers = xml.documentElement.getElementsByTagName("marker");
			var liste = '<ul class="list-group list-group-flush">';
			let kartenpunkte = [];
			for (var i = 0; i < markers.length; i++) {
				var id_track = markers[i].getAttribute("id_track");
				var trackname = markers[i].getAttribute("trackname");
				var username = markers[i].getAttribute("username");
				var distance = markers[i].getAttribute("distance");
				var privat = markers[i].getAttribute("privat");
				
				var color = '#' + markers[i].getAttribute("trackColor");
				if(color=='#'){
					var color = randomColor();
				}
				
				kartenpunkte.push(createMarkerTrack(markers[i]));
				
				var liste = liste + '<a href="javascript:showTrackGpx(' + id_track + ');" class="list-group-item" id="' + id_track + '" style="border-left: 10px solid ' + color + ';" onmouseover="showTrackMultiple(' + id_track + ',\'' + color + '\')" onmouseout="hideTrack(' + id_track + ');">' + trackname + '<br><span class="badge bg-warning">' + distance + ' m</span> <span class="badge bg-info">' + username + '</span>';
				if(privat == 1){
					var liste = liste + ' <i>(privat)</i>';
				}
				var liste = liste + '<div id="detailsTrack' + id_track + '" class="trackoptions" style="display:none"></div></a>';
			}
			drawMapPoints(map,kartenpunkte);

			var liste = liste + '</ul>';
			if(anzahl >= 11){
				var liste = liste + '<nav aria-label="mehr anzeigen" class="mb-1">';
					var liste = liste + '<ul class="pagination pagination-sm justify-content-center">';
						if(backer>=0){
							var liste = liste + '<li class="page-item"><a class="page-link" href="javascript:callTracks(' + backer + ');" aria-label="vorhergehende"><span aria-hidden="true">&laquo;</span></a></li>';
						}
						if(jumper<anzahl){
							var liste = liste + '<li class="page-item"><a class="page-link" href="javascript:callTracks(' + jumper + ');" aria-label="nächste"><span aria-hidden="true">&raquo;</span></a></li>';
						}
					var liste = liste + '</ul>';
				var liste = liste + '</nav>';		
			}
			document.getElementById('trackliste').innerHTML = liste;
			waitDone();
		});
	}
}
window.callTracks = callTracks;

function randomColor(){
	var color="#";
	for (var x=0;x<6;x++){
		color+="0123456789ABCDEF".charAt (Math.round (Math.random ()*1000)%16);
	}
	return color;
}

function setMapView(karte,position,zoom){
	karte.getView().animate({zoom: zoom, center: fromLonLat(position)});    
}
window.setMapView = setMapView;

function wrapLon(value) {
	const worlds = Math.floor((value + 180) / 360);
	return value - worlds * 360;
}

function logStatus(){
	let layers = map.getLayers();
	console.log(layers);
	let overlays = map.getOverlays();
	console.log(overlays);
	console.log("Layers: "+layers.getLength());
	console.log("Overlays: "+overlays.getLength());
}

function startTrackGpx(){
	deleteOverlays(map);
	refreshsperre = 1;
	points = [];
	$('#actionArea').html('<button class="btn btn-sm btn-danger" type="button" onclick="stopTrackGpx();"><span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span> Recording...</button>');
	$('#track').html('<div class="badge bg-secondary" id="distance"></div>');
	$('#actionArea').show();
	$('#track').show();
	map.on('click', function (evt) {
		const feature = map.forEachFeatureAtPixel(evt.pixel, function (feature) {
			return feature;
		});
		disposePopover();
		let element = document.createElement('div');
		element.setAttribute("id", "popup-create");
		const popup = new Overlay({
			element: element,
			positioning: 'bottom-center',
			stopEvent: false,
		});
		map.addOverlay(popup);
		if (!feature) {
			var coordinates = evt.coordinate;
			var waypoint = [];
			waypoint["osm"] = coordinates;
			var lonLat = toLonLat(coordinates);
			waypoint["lon"] = lonLat[0];
			waypoint["lat"] = lonLat[1];
			points.push(waypoint);
			plotTrack('#000000',false,true);
		}
		else{
			popup.setPosition(evt.coordinate);
			popover = new bootstrap.Popover(element, {
				placement: 'top',
				html: true,
				sanitize: false,
				content: feature.get('html'),
			});
			popover.show();
		}
		
	});
}
window.startTrackGpx = startTrackGpx;

function stopTrackGpx(){
    //map.removeInteraction(draw);
	document.getElementById('actionArea').style.display = 'block';
	var html = 'Soll die Strecke gesichert werden?<br /><form action="javascript:saveTrackGpx();" name="FormName" method="get"><input type="text" name="track_name" class="form-control" placeholder="Gib ihr einen Namen" />';
	if(id_user>=1){
		var html = html + '<input class="form-check-input mr-1" type="checkbox" name="privat" value="1" /> privat (nur für mich sichtbar)';
	}
	else{
		var html = html + '<input type="hidden" name="privat" value="0" />';
	}
	var html = html + '<div class="d-grid gap-2"><button class="btn btn-sm btn-primary" type="submit" >sichern</button></div></form>';
	$("#actionArea").html(html);
}
window.stopTrackGpx = stopTrackGpx;

function saveTrackGpx(){
	var id_track;
	distance = 0;
	var trackColor = randomColor().replace('#','');
	var pointsToSave = [];
	for (var i=0;i <= points.length-1;i++) {
		var lon = points[i].lon;
		var lat = points[i].lat;
		pointsToSave.push([lat,lon]);
		if(i>=1){
			var entfernung = distanzberechnung(lat,lon,prevlat,prevlon);
			var distance = distance + entfernung;
		}
		var prevlon = lon;
		var prevlat = lat;
	}
	if(document.FormName.privat.checked==true){
		var privat = "1";
	}
	else{
		var privat = "0";
	}
	var data = {'points[]':pointsToSave,track:document.FormName.track_name.value,distance:distance,trackColor:trackColor,privat:privat};
	var url = "_process/savetrack.php";
	$.post(url,data,function(data){
		document.location.href = 'track.php?id_track=' + data;
	});
}
window.saveTrackGpx = saveTrackGpx;

function updateTrack(id_track){
	distance = 0;
	var pointsToSave = [];
	for (var i=0;i <= points.length-1;i++) {
		var lon = points[i].lon;
		var lat = points[i].lat;
		pointsToSave.push([lat,lon]);
		if(i>=1){
			var entfernung = distanzberechnung(lat,lon,prevlat,prevlon);
			var distance = distance + entfernung;
		}
		var prevlon = lon;
		var prevlat = lat;
	}
	var data = {'points[]':pointsToSave,id_track:id_track,distance:distance};
	var url = "_process/updatetrack.php";
	
	$.post(url,data,function(data){
		$("#distance").html('Daten werden gesichert. Moment...');
		document.location.reload();
	});
}
window.updateTrack = updateTrack;

function distanzberechnung(lat1,lon1,lat2,lon2) {
	var R = 6371; // km (change this constant to get miles)
	var dLat = (lat2-lat1) * Math.PI / 180;
	var dLon = (lon2-lon1) * Math.PI / 180;
	var a = Math.sin(dLat/2) * Math.sin(dLat/2) + Math.cos(lat1 * Math.PI / 180 ) * Math.cos(lat2 * Math.PI / 180 ) * Math.sin(dLon/2) * Math.sin(dLon/2);
	var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
	var d = R * c;
	return Math.round(d*1000);
}

function kilometermarkeWaypoint(latA,lonA,latB,lonB,distA,distB){
	var lonX = parseFloat(lonA) + (((lonB-lonA)*(Math.ceil(distA/1000)-(distA/1000)))/((distB/1000)-(distA/1000)));
	var latX = parseFloat(latA) + (((latB-latA)*(Math.ceil(distA/1000)-(distA/1000)))/((distB/1000)-(distA/1000)));
	var waypoint = fromLonLat([parseFloat(lonX), parseFloat(latX)]);
	return waypoint;
}

function showTrackGpx(id_track){
	refreshsperre = 1;
	points = [];
	var url="_process/calltrack.php?id_track=" + id_track;	
	downloadUrl(url, function(data){
		var xml = parseXml(data);
		var waypoints = xml.documentElement.getElementsByTagName("waypoint");
		var track_name = xml.documentElement.getElementsByTagName("track")[0].getAttribute("bezeichnung");
		var track_color = xml.documentElement.getElementsByTagName("track")[0].getAttribute("color");
		var track_locked = xml.documentElement.getElementsByTagName("track")[0].getAttribute("locked");
		var track_user = xml.documentElement.getElementsByTagName("user")[0].getAttribute("username");
		var track_id_user = xml.documentElement.getElementsByTagName("user")[0].getAttribute("id_user");
		for (var i = 0; i < waypoints.length; i++) {
			var waypoint = [];
			waypoint["osm"] = createCoordinate(waypoints[i]);
			waypoint["lon"] = waypoints[i].getAttribute("lon");
			waypoint["lat"] = waypoints[i].getAttribute("lat");
			points.push(waypoint);
		}
		var html = '';
		var html = html + '<div class="d-grid gap-2 mt-1"><a href="track.php?id_track=' + id_track + '" class="btn btn-sm btn-primary">aufrufen</a></div>';
		$("#detailsTrack" + id_track).html(html);
		$("#detailsTrack" + id_track).toggle();
		plotTrack('#990000');
	});
}
window.showTrackGpx = showTrackGpx;

function showTrackMultiple(id_track,color){
	if(refreshsperre!=1){
		var points = new Array();
		var trackname = 'track' + id_track;
		var url="_process/calltrack.php?id_track=" + id_track;	
		downloadUrl(url, function(data){
			var xml = parseXml(data);
			var waypoints = xml.documentElement.getElementsByTagName("waypoint");
			for (var i = 0; i < waypoints.length; i++) {
				var waypoint = [];
				waypoint["osm"] = createCoordinate(waypoints[i]);
				waypoint["lon"] = waypoints[i].getAttribute("lon");
				waypoint["lat"] = waypoints[i].getAttribute("lat");
				points.push(waypoint);
			}
			var currentLine = drawLine(points,color);
			streckenArray.push(currentLine);
		});
	}
}
window.showTrackMultiple = showTrackMultiple;

function createCoordinate(waypoint){
    return fromLonLat([parseFloat(waypoint.getAttribute("lon")), parseFloat(waypoint.getAttribute("lat"))]);
}

function initializeTrackEditListeners(){
	map.on('click', function (evt) {
		const feature = map.forEachFeatureAtPixel(evt.pixel, function (feature) {
			return feature;
		});
		disposePopover();
		if (!feature) {
			return;
		}
		popup.setPosition(evt.coordinate);
		popover = new bootstrap.Popover(element, {
			placement: 'top',
			html: true,
			sanitize: false,
			content: feature.get('html'),
		});
		popover.show();
	});
	//const element = document.getElementById('popupEdit');
	let element = document.createElement('div');
	element.setAttribute("id", "popup-edit");
	const popup = new Overlay({
		element: element,
		positioning: 'bottom-center',
		stopEvent: false,
	});
	map.addOverlay(popup);
}

function editTrack(id_track){
	$("#distance").html("Warte kurz - der Bearbeitungsmodus wird geladen.");
	points = [];
	var url="_process/calltrack.php?id_track=" + id_track;	
	downloadUrl(url, function(data){
		var xml = parseXml(data);
		var waypoints = xml.documentElement.getElementsByTagName("waypoint");
		var track_name = xml.documentElement.getElementsByTagName("track")[0].getAttribute("bezeichnung");
		for (var i = 0; i < waypoints.length; i++) {
			var waypoint = [];
			waypoint["osm"] = createCoordinate(waypoints[i]);
			waypoint["lon"] = waypoints[i].getAttribute("lon");
			waypoint["lat"] = waypoints[i].getAttribute("lat");
			points.push(waypoint);
		}
		plotTrack(trackStandardFarbe,false,true);
		$("#distance").html("Leg los. Du kannst jetzt die einzelnen Punkte verschieben.");
		initializeTrackEditListeners();
	});	
}
window.editTrack = editTrack;

function plotTrack(track_color,fitToView=true,editmode=false){
	deleteOverlays(map);
	var markerpoints = [];
	distance = 0;
	var anzPoints = points.length-1;
	//console.log(anzPoints);
	for (var i=0;i <= anzPoints;i++) {
		var point = points[i].osm;
		var lon = points[i].lon;
		var lat = points[i].lat;
		// Infowindowcontent auch nur setzen, wenn Marker visible?
		var infowindowcontent = setInfowindowContent(i);
		if(i==0){
			var marker = createDisplayMarker(map,point,iconStart,'',i,editmode,infowindowcontent);
			markerpoints.push(marker);
		}
		else{
			var entfernung = distanzberechnung(lat,lon,prevlat,prevlon);
            if(i==points.length-1){
				var marker = createDisplayMarker(map,point,iconZiel,'',i,editmode,infowindowcontent);
				markerpoints.push(marker);
				
            }
            else{
				if(editmode){
					let visible = punktIstInMapView(map,point);
					if(visible==true){
						var marker = createDisplayMarker(map,point,iconPoint,'',i,editmode,infowindowcontent);
						markerpoints.push(marker);
						let currentMapBounds = getCurrentMapCoordinates(map);

					}
				}
            }
			if(i>=2){
				if(Math.ceil(distance/1000)!=Math.ceil((distance + entfernung)/1000)){
					var kilometerpunkt = kilometermarkeWaypoint(prevlat,prevlon,lat,lon,distance,(parseFloat(distance) + parseFloat(entfernung)));
					var thisKilometerstein = Math.ceil(distance/1000);
					
					let visible = punktIstInMapView(map,kilometerpunkt);
					if(visible==true){
						var marker = createDisplayMarker(map,kilometerpunkt,iconKilometermarke,''+thisKilometerstein,'',false,'');
						markerpoints.push(marker);
					}
					
				}
			}
			var distance = distance + entfernung;
        }
		var prevlon = lon;
		var prevlat = lat;
	}
    var currentLine = drawLine(points,track_color);
    createPoints(map,markerpoints,currentLine);
	if(fitToView){
		map.getView().fit(currentLine.getSource().getExtent(),{ 
			duration: 1000, 
			padding:[100,100,100,100], 
			size: map.getSize(),
		});
	}
	streckenArray.push(currentLine);
	if(editmode){
		$("#distance").html("Distanz: " + Math.round(distance/10)/100 + "km");
	}
	logStatus();
}

function dateiAuslesen(datei){
	fetch(datei)
	.then((response) => {
		if (!response.ok) {
			throw new Error("Failed to fetch the file")
		}
		return response.text()
	})
	.then((data) => {
		const [parsedFile, error] = parseGPX(data)
		
		// Or use a try catch to verify
		if (error) throw error
		
		var distance = parsedFile.tracks[0].distance.total;
		
		var waypoints = parsedFile.tracks[0].points;
		
		var trackstring = '';
		
		for (var i = 0; i < waypoints.length; i++) {
			var waypoint = [];
			waypoint["osm"] = fromLonLat([parseFloat(waypoints[i].longitude), parseFloat(waypoints[i].latitude)]);
			waypoint["lon"] = waypoints[i].longitude;
			waypoint["lat"] = waypoints[i].latitude;
			
			if(i==0){
				var trackstring = trackstring + '(' + waypoint["lat"] + '|' + waypoint["lon"] + '),';
				var startzeit = waypoints[i].time;
				var prevpoint = waypoint;
			}
			else{
				if(distanzberechnung(waypoint["lat"],waypoint["lon"],prevpoint["lat"],prevpoint["lon"])>=1){
					points.push(waypoint);
					var trackstring = trackstring + '(' + waypoint["lat"] + '|' + waypoint["lon"] + '),';
					var stopzeit = waypoints[i].time;
					var prevpoint = waypoint;
				}
			}
			points.push(waypoint);
		}
				
		var startzeit = new Date(startzeit);
		var stopzeit = new Date(stopzeit);
		var duration = stopzeit - startzeit;
		var duration = secondsToTime(duration);
		var datum = formatDate(startzeit);
		plotTrack('#990000');
		var html = "<p><strong>Zeit: " + duration + ". Strecke: " + Math.round(distance/10)/100 + "km</strong></p>";
		var html = html + '<div class="copy">Track sichern? Er kann danach noch bearbeitet werden.</div>';
		var html = html + '<form action="javascript:saveGpxTrack();" id="savegpxtrack">';
		var html = html + '<input type="hidden" name="datum" value="' + datum + '" />';
		var html = html + '<input type="hidden" name="trackname" value="Lauf ' + datum + '" />';
		var html = html + '<input type="hidden" name="zeit" value="' + duration + '" />';
		var html = html + '<input type="hidden" name="trackstring" value="' + trackstring + '" />';
		var html = html + '<input type="hidden" name="distance" value="' + distance + '" />';
		var html = html + '<input type="submit" class="btn btn-primary btn-sm" value="sichern" />';
		var html = html + '</form>';
		$("#gpxUpload").html(html);
		
	})
}
window.dateiAuslesen = dateiAuslesen;

function uploadLoeschen(dateiname){
	$.post("/_ajax/deleteUpload.php",{file:dateiname},function(data){
	});
}

function deleteTrackGpx(id_track){
	$.get("_process/deletetrack.php",{id_track:id_track},function(data){
		$("#deleteTrack").html("Strecke gelöscht - warte kurz - Du wirst weitergeleitet...");
		document.location.href = 'map.php';
	});
}
window.deleteTrackGpx = deleteTrackGpx;

function createPoints(karte,kartenpunkte,linie){
	//let vectorSource = new VectorSource({
		//features: kartenpunkte,
	//});
	vectorSource.addFeatures(kartenpunkte);
	let vectorLayer = new VectorLayer({
		source: vectorSource,
	});
	let layer = [
		new TileLayer({
			source: new OSM()
		}),
		linie,
		vectorLayer 
	];
	karte.setLayers(layer);
}

function drawLine(points,color){
    var layerLines = createLine(points,color);
    map.addLayer(layerLines);
    return layerLines;
}

function createLine(points,color){
    var osmpoints = [];
    for (var i = 0; i < points.length; i++) {
        osmpoints.push(points[i].osm);
    }
    var layerLines = new VectorLayer({
        source: new VectorSource({
            features: [new Feature({
                geometry: new LineString(osmpoints),
                name: 'Line'
            })]
        }),
        style: new Style({
            stroke: new Stroke({
                color: color,
                width: 3
            })
        })
    });
    return layerLines;
}

function deleteOverlays(karte){
	removeAllOverlays(karte);
	removeLines(karte);
	removeFeatures(karte);
}

function removeFeatures(karte){
	disposePopover();
	vectorSource.clear();
}

function removeLines(karte){
	if (streckenArray) {
		for (var i=0; i<streckenArray.length; i++) {
			karte.removeLayer(streckenArray[i]);
		}
		streckenArray.length = 0;
	}
}
window.removeLines = removeLines;

function removeAllOverlays(karte){
	//karte.getOverlays().clear();
	drawMapPoints(karte,[]);
}

function createMarker(marker,infowindow){
	let kartenpunkt = new Feature({
		geometry: new Point(fromLonLat([parseFloat(marker.getAttribute("lon")), parseFloat(marker.getAttribute("lat"))])),
		html: infowindow,
	});
	kartenpunkt.setStyle(
		new Style({
			image: new Icon({
				crossOrigin: 'anonymous',
				src: iconLauf,
			}),
			text: new Text({
				text:'',
			}),
		})
	);
	return kartenpunkt;
}

function createMarkerVolkslaufkalender(marker){
	let infowindow = '<div class="infowindow"><a href="volkslaufkalenderEintrag.php?id_volkslauf=' + marker.getAttribute("id_volkslauf") + '" class="btn btn-sm btn-primary">' + marker.getAttribute("volkslauf_name") + '</a><br />' + marker.getAttribute("datum") + '</div>'
	return createMarker(marker,infowindow);
}

function createMarkerTrack(marker){
	let infowindow = '<h2>' + marker.getAttribute("trackname") + '<\/h2>' + marker.getAttribute("distance") + 'm' + '<a href="track.php?id_track=' + marker.getAttribute("id_track") + '" class="btn btn-primary w-100">aufrufen</a>';
	return createMarker(marker,infowindow);
}

// wird aktuell nicht benutzt, behalten wir aber noch. Wichtige Grundfunktion
function getMapBounds(){
    var bounds = map.getView().calculateExtent(map.getSize());
    return bounds;
}

function insertMarkerGpx(id){
	disposePopover();
	var ersterPunktLat = parseFloat(points[id]["lat"]);
	var ersterPunktLon = parseFloat(points[id]["lon"]);
	var zweiterPunktLat = parseFloat(points[id-1]["lat"]);
	var zweiterPunktLon = parseFloat(points[id-1]["lon"]);
	var waypoint = [];
	waypoint["lon"] = parseFloat(ersterPunktLon - ((ersterPunktLon-zweiterPunktLon)/2));
	waypoint["lat"] = parseFloat(ersterPunktLat + ((zweiterPunktLat-ersterPunktLat)/2));
	waypoint["osm"] =fromLonLat([waypoint["lon"], waypoint["lat"]]);
	points.splice(id,0,waypoint);
	plotTrack(trackStandardFarbe,false,true);
}
window.insertMarkerGpx = insertMarkerGpx;

function takeMeHomeGpx(id){
	disposePopover();
	for(var i=id; i>=0; i--){
		points.push(points[i]);
		plotTrack(trackStandardFarbe,false,true);
	}
}
window.takeMeHomeGpx = takeMeHomeGpx;

function createDisplayMarker(karte,point,icon,textcontent,id,draggable=false,html='') {
    let kartenpunkt = new Feature({
        geometry: new Point(point),
        html: html,
		id:id,
    });
    kartenpunkt.setStyle(
        new Style({
            image: new Icon({
                crossOrigin: 'anonymous',
                src: icon,
            }),
            text: new Text({
                text:textcontent,
            }),
        })
    );
    if(draggable){
		var dragInteraction = new Translate({
			features: new Collection([kartenpunkt])
		});
		
		dragInteraction.on('translateend', function(evt) {
		//dragInteraction.on('translating', function(evt) {
			var coordinates = evt.features.getArray()[0].getGeometry().getCoordinates();
			var waypoint = [];
			waypoint["osm"] = coordinates;
			var lonLat = toLonLat(coordinates);
			waypoint["lon"] = lonLat[0];
			waypoint["lat"] = lonLat[1];
			points[id] = waypoint;
			plotTrack(trackStandardFarbe,false,true);
			initializeTrackEditListeners();
		});
		
		karte.addInteraction(dragInteraction);
    }
	return kartenpunkt;
}

function setInfowindowContent(id){
	var infowindowHtml = '';
	var infowindowHtml = infowindowHtml + '<a href="javascript:removeMarkerGpx(' + id + ');" class="btn btn-sm btn-danger w-100 mb-1">Diesen Punkt löschen</a>';
	var infowindowHtml = infowindowHtml + '<a href="javascript:insertMarkerGpx(' + id + ');" class="btn btn-sm btn-primary w-100 mb-1">Punkt einfügen</a>';
	var infowindowHtml = infowindowHtml + '<a href="javascript:takeMeHomeGpx(' + id + ');" class="btn btn-sm btn-success w-100 mb-1">Ab nach Hause...</a>';
    return infowindowHtml;
}

function laufzeitSichern(id_track){
	var data = $('#LaufzeitForm').serialize();
	$.post("_process/saveLaufzeit.php",data,function(data){
		$("#registrationarea").html(data);
		$("#dialog").dialog('close');
		document.location.reload();
	});
}
window.laufzeitSichern = laufzeitSichern;

function initializeDatepicker(){
	$.datepicker.setDefaults({
		dateFormat:'dd.mm.yy',
		dayNames:['Sonntag','Montag','Dienstag','Mittwoch','Donnerstag','Freitag','Samstag'],
		dayNamesMin:['So','Mo','Di','Mi','Do','Fr','Sa'],
		firstDay:1,
		monthNames:['Januar','Februar','M&auml;rz','April','Mai','Juni','Juli','August','September','Oktober','November','Dezember'],
		monthNamesShort:['Jan','Feb','Mar','Apr','Mai','Jun','Jul','Aug','Sep','Okt','Nov','Dez']
	});
	$(".datepicker").datepicker();
}
window.initializeDatepicker = initializeDatepicker;

function gpxUpload(){
	$("#gpx-upload-form").on('submit', function(e) {
		e.preventDefault();
		$("#gpxUpload").html('<img src="/wait.gif" />');
		$.ajax({
			url: "_ajax/gpxUpload.php",
			type: "POST",
			data:  new FormData(this),
			contentType: false,
			cache: false,
			processData: false,
			beforeSend: function() {
				$("#err").fadeOut();
			},
			success: function(response) {
				if (response == 'invalid') {
					$("#err").html("Invalid File!").fadeIn();
				} else {
					$("#gpxUpload").html(response);	
					dateiAuslesen(response); 
				}
			},
			error: function(e) {
				$("#err").html(e).fadeIn();
			}          
		});
	});
}
window.gpxUpload = gpxUpload;

function saveGpxTrack(){
	var daten = $("#savegpxtrack").serialize();
	$.post("/_process/savegpxtrack.php",daten,function(data){
		$("#gpxUpload").html("warte kurz - Du wirst weitergeleitet...");
		var id_track = data;
		document.location.href = 'track.php?id_track=' + id_track;
	});
}
window.saveGpxTrack = saveGpxTrack;

var vectorSource = new VectorSource();

function drawMapPoints(karte,kartenpunkte){
	karte.getOverlays().clear();
	vectorSource.clear();
	vectorSource.addFeatures(kartenpunkte);
    const clusterSource = new Cluster({
      distance: distanceInput,
      minDistance: minDistanceInput,
      source: vectorSource,
    });
    const styleCache = {};
    const clusters = new VectorLayer({
      source: clusterSource,
      style: function (feature) {
        const size = feature.get('features').length;
        let style = styleCache[size];
        if(size==1){
          style = feature.get('features')[0].getStyle();
        }
        else{
          if (!style) {
            style = new Style({
              image: new Icon({
                crossOrigin: 'anonymous',
                src: '/images/jogging.png',
              }),
              text: new Text({
                text: size.toString(),
				font: 'bold 12px sans-serif',
				offsetX: 10,
				offsetY: -10,
                fill: new Fill({
                  color: '#fff',
                }),
              }),
              //html: '',
            });
            styleCache[size] = style;
          }
        }
        return style;
      },
    });
    const raster = new TileLayer({
      source: new OSM(),
    });
    karte.setLayers([raster, clusters]);
	
    karte.on('click', (e) => {
      	disposePopover();
	  	clusters.getFeatures(e.pixel).then((clickedFeatures) => {
        	if (clickedFeatures.length) {
				const features = clickedFeatures[0].get('features');
				if (features.length > 1) {
					let newZoom = karte.getView().getZoom()+2;
					if(newZoom <= karte.getView().getMaxZoom()){
						karte.getView().animate({zoom: newZoom, center: features[0].getGeometry().getCoordinates()});
					}
				}
				else{
					popup.setPosition(e.coordinate);
					popover = new bootstrap.Popover(element, {
						trigger: 'hover focus',
						placement: 'top',
						html: true,
						content: features[0].get('html'),
					});
					popover.show();
				}
        	}
  	  	});
    });
	
	karte.on('movestart', disposePopover);
	
	//const element = document.getElementById('popup');
	let element = document.createElement('div');
	element.setAttribute("id", "popup-test");
	const popup = new Overlay({
		element: element,
		positioning: 'bottom-center',
		stopEvent: false,
	});
	karte.addOverlay(popup);
	
}

function drawMapPoint(kartenpunkt,target){
  let vectorSourceSingle = new VectorSource({
    features: [kartenpunkt],
  });
  let vectorLayerSingle = new VectorLayer({
    source: vectorSourceSingle,
  });
  let layerSingle = [
    new TileLayer({
      source: new OSM()
    }),
    vectorLayerSingle
  ];
  target.setLayers(layerSingle);  
}

